import { useTranslation } from 'react-i18next'
import { Button, Tooltip } from '@mui/material'
import LanguageIcon from '@mui/icons-material/Language'

interface LanguageSwitcherProps {
  color?: 'inherit' | 'primary'
  size?: 'small' | 'medium' | 'large'
}

export default function LanguageSwitcher({ color = 'inherit', size = 'small' }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation()
  const currentLang = i18n.language.startsWith('fr') ? 'fr' : 'en'
  const nextLang = currentLang === 'fr' ? 'en' : 'fr'

  const handleClick = () => {
    void i18n.changeLanguage(nextLang)
  }

  return (
    <Tooltip title={t('language.switchTo', { lang: t(`language.${nextLang}`) })}>
      <Button
        onClick={handleClick}
        color={color}
        size={size}
        startIcon={<LanguageIcon />}
        sx={{ textTransform: 'uppercase', minWidth: 0 }}
      >
        {nextLang}
      </Button>
    </Tooltip>
  )
}
